import { ApiProperty } from "@nestjs/swagger";
import { MessageTypeEnum, PriorityEnum } from "@schemax-whatsapp/shared-models";


export class BroadcastMessageRequest {
    @ApiProperty()
    companyId: number;
    @ApiProperty()
    templateName: string;
    @ApiProperty()
    templateLanguage: string;
    @ApiProperty()
    messageParams: JSON;
    @ApiProperty({type: [String]})
    contacts: string[];
    @ApiProperty()
    username: string;
    @ApiProperty()
    fileName?: string;
    @ApiProperty()
    filePath?: string;
    @ApiProperty()
    id?: number;

    /**
     * 
     * @param companyId 
     * @param templateName
     * @param priority 
     * @param messageType 
     * @param message 
     * @param contacts 
     * @param broadcastName
     * @param username 
     */
    constructor(companyId: number, templateName: string, templateLanguage: string, messageParams: JSON, contacts: string[], username: string,filename?:string,filePath?:string,id?:number) {
        this.companyId = companyId;
        this.templateName = templateName;
        this.templateLanguage = templateLanguage;
        this.messageParams = messageParams;
        this.contacts = contacts;
        this.username = username;
        this.fileName = filename;
        this.filePath = filePath;
        this.id = id;
    }
}